<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="pb-3" style="margin:auto;max-width:600px;">

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    خرید و فروش فوری
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        در هر لحظه, به سرعت و سادگی بخرید و بفروشید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_bear_market.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Transaction'}" class="ar-btn size-sm round primary mx-3">ورود </router-link>
                    </div>

                  </div>
                </div>
              </div>

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    تبدیل کریپتو به تتر/تومان
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        هر نوع ارز دیجیتال معتبر خود را به سادگی بفروشید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_crypto_portfolio.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'ConvertCrypto'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>

              <div class="ar-card size-sm over-visible mb-4">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                    تاریخچه مبادلات
                  </div>
                </div>
                <div class="ar-card-body p-0">
                  <div class="poster-wrapper">

                    <div class="poster-inner">
                      <div class="poster-text">
                        سوابق مبادلات خود را همیشه در دسترس داشته باشید.
                      </div>
                      <div class="poster">
                        <img :src="StaticImageUrl+'assets/images/undraw_notes.svg'">
                      </div>
                    </div>

                    <div class="poster-actions">
                      <router-link :to="{name:'Records'}" class="ar-btn size-sm round primary mx-3">ورود</router-link>
                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
export default {
  name: 'Exchanges',
  components:{
    Sidebar,
    HelperNav,
    Header,
  },
  data : () => ({
  }),
  methods:{
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
  }
}
</script>